import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QrReader } from 'react-qr-reader';
import moment from 'moment';
import 'moment-timezone';
import TimePicker from 'rc-time-picker';
import './App.css';
import gpsIcon from "./img/gps.png";
import googleIcon from "./img/google-play.png";
import iosIcon from "./img/ios-appstore.png";
import { getStripeError } from './static';
import notAllowed from "./img/exclamation-mark.png";
import calendarIcon from "./img/calendar.png";
import cameraIcon from "./img/camera-qr.png";
import qrcode from "./img/qrcode.png";
import 'rc-time-picker/assets/index.css'; 
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ExpandTray from './ExpandTray';

export const UPCOMING_REQUEST = "UPCOMING_REQUEST"
export const PAST_REQUEST = "PAST_REQUEST"

export default class App extends Component {

  constructor(props){
    super(props);
    this.getCarRequestedList = this.getCarRequestedList.bind(this);
    this.cancelCarRequest = this.cancelCarRequest.bind(this);
    this.initForm = this.initForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCalendarDateChange = this.handleCalendarDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCalendarScheduleCar = this.handleCalendarScheduleCar.bind(this);
    this.handleCarRequestedIconClicked = this.handleCarRequestedIconClicked.bind(this);
    this.hours = [];
    this.mins = [];
    const urlParams = new URLSearchParams(window.location.search);
    this.baseUrl = process.env.REACT_APP_API_URL;
    this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
    this.isDev = process.env.REACT_APP_ENVIRONMENT == "DEV";
    this.isProd = process.env.REACT_APP_ENVIRONMENT == "PROD";
    this.initialState =  {
      booking: {},
      parkingType:'',
      showWarning: false,
      loading: false,
      booked: false,
      showCarRequestedPopUp: false,
      tipAmount: 0,
      isPayRequestCar: false,
      isHideRequestCar: true,
      isOnlyCard: false,
      tipConfig: {},
      requestList: [],
      displayPast: false,
      displayUpcoming: false,
      requestType: UPCOMING_REQUEST,
      scheduledCarReqTime: null,
      timeZone: "",
      guest: null,
      o_guest: null,
      checkout_date: null,
      selectedTime: moment().hour(0).minute(0),
      selectedDate: moment().toDate(),
      user_id: '',
      fields: {
        areaCode: 1,
        hours: 0,
        mins: 0,
        email: ''
      },
      errors: {}
    }
    this.state = this.initialState;
  } 
  componentDidMount(){
    const defer = () =>  {
      if (window.Stripe) {
          this.initForm(this);
      } else {
          setTimeout(function() { defer ()  }, 50);
      }
    }
    this.refreshAfterSleep();
    defer();
  }

handleCarRequestedIconClicked(){
  this.setState({showCarRequestedPopUp: true})
}

handleCloseCarRequestedPopUp(){
  this.setState({showCarRequestedPopUp: false})
}

handleCalendarTimeChange = (value) => {
    this.setState({ selectedTime: value._d});

}
handleCalendarDateChange = (date) => {
  this.setState({ selectedDate:date });
};
  refreshAfterSleep(){
    var SAMPLE_RATE = 5000; 
    var lastSample = Date.now();
    
    function refresh() {
      if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
      window.location.reload();
      }
      lastSample = Date.now();
      setTimeout(refresh, SAMPLE_RATE);
    }
    refresh();
  }

  manageBodyBackground(isShow){
    if(isShow){
      document.querySelector('#root').classList.add('dark');
    }else{
      document.querySelector('#root').classList.remove('dark');
    }
  }

  deduceFreeParking(data){
    const isFreeParking = data.parking_fee - data.paid_amount - data.discount_amount - data.validation_amount <= 0;
    return isFreeParking;
  }

  checkIfDollar2Tip(data){
    let result = false;
    if(this.defaultDollar2TipListId.includes(data.parking_id)){
      result = true;
    }else{
      let contractorList = [5830];
      if(data.special_price === "contractor" && contractorList.includes(data.parking_id)){
        result = true;
      }
    }

    return result;
  }

  getTipDefaultAmount(isTipPercent, parkingFee, isNoTipBtn, defaultTip, parkingId) {
    return isTipPercent ? ((18 / 100) * (parkingFee / 100)) : isNoTipBtn ? 0 : defaultTip ? defaultTip : 0
  }

  getBookingDetails(isAfterCouponApply){
    const urlParams = new URLSearchParams(window.location.search);
    let bookingId = urlParams.get('id');
    let isOnlyCard = urlParams.get('card');
    if(!bookingId){
      toast.dismiss();
      toast.error("Params missing in URL!");
      return;
    }
    this.setState({loading: true})
    fetch(`${this.baseUrl}/parking/valet/booking/info/hash?hash=${bookingId}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            let fields = this.state.fields;
            let data = resp.data;
            fields["coupon"] = data.coupon_code;
            const permissions = data.permissions || {};
            const isVisitor = data.guest != "true" && (data.monthly_parker === "false" || !data.monthly_parker) && data.resident != "true";
            const isMultipleTipsAllowed = permissions.valetpay_multiple_tips;
            const isShowOnlyTip = isVisitor && permissions.valetpay_only_tip;
            const isFreeParking = isShowOnlyTip ? true : this.deduceFreeParking(data);
            const parkingId = data.parking_id;
            const isPartialPaid = data.payment_status === "partial_paid";
            const isOnlyPaid = data.payment_status === 'paid';
            const isNoTipBtn = permissions.valetpay_no_tip_btn;
            const isTipPercent = permissions.valetpay_tip_percent;
            const isDefaultDollar2Tip = permissions.valetpay_dollar2tip ? true : permissions.special_price === "contractor" && permissions.valetpay_contractor ? true : false;
            const isShowRequestCarCase = data.guest === "true" && data.car_requested === "false" && data.additional_status === "out" && data.payment_type === "card";
            const tipConfig = permissions.tip_config;
            const isQRScanLot = parkingId == 5962 || parkingId == 5963 || parkingId == 5693;
            if(data.external_user_id){
              this.getCarRequestedList(data.external_user_id);
            }
            this.setState({ 
              fields,
              couponApplied: data.discount_amount || (isQRScanLot && data.coupon_code) ? true : false,
              discountAmount: data.discount_amount ? data.discount_amount : 0,
              bookingId,
              booking: isShowOnlyTip ? { ...data,
                         parking_charge: 0,
                         paid_amount: 0,
                         parking_fee: 0,
                         conv_fee: 0,
                         convenience_fee: 0
                      } : data, 
              hidePayBtn: data.payment_status == 'paid' && !isMultipleTipsAllowed ? true : false,
              carRequested: data.car_requested == 'true' ? true : false,
              carReady: data.car_ready == 'true' ? true : false,
              loading: false,
              isFreeParking,
              isHideRequestCar: permissions.valetpay_hide_request_car,
              isShowTerms: permissions.valetpay_terms_conditions,
              isShowHotelTerms: permissions.valetpay_hotel_terms,
              isPayRequestCar: data.o_guest === "true" || data.guest === "true" ? false : isShowRequestCarCase ? false : permissions.valetpay_pay_and_request,
              isOnlyCard: isOnlyCard ? true : false,
              isNoTipBtn,
              isPartialPaid,
              isOnlyPaid,
              isTipPercent,
              parkingId,
              isDefaultDollar2Tip,
              showPaymentDetails: isOnlyCard ? true : this.state.showPaymentDetails,
              tipAmount: this.getTipDefaultAmount(isTipPercent, data.parking_fee, isNoTipBtn, this.state.tipAmount || tipConfig?.default_tip_amount, parkingId),
              tipConfig,
              isShowOnlyTip,
              isMultipleTipsAllowed,
              // isV2API: parkingId == 5693 && !this.isProd,
              isV2API: true,
              guest: data.guest=== "true" ? true : false,
              o_guest: data.o_guest=== "true"? true : false,
              checkout_date: data.check_out,
              timeZone: data.timezone,
              user_id: data.external_user_id,
              isQRScanLot,
              isHideApplyCoupon: data.coupon_code && isQRScanLot
            }, () => {
              if(isAfterCouponApply){
                if(this.state.isQRScanLot && !this.state.discountAmount){
                  toast.error('Coupon validity expired');
                }else if(!this.state.isQRScanLot){
                  toast.error('Invalid coupon');
                }
              }
            });
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            this.setState({loading: false});
            toast.dismiss();
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          this.setState({loading: false});
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  requestCar(){
    const requestCarBtn = document.getElementById("car-request-btn");
    if(requestCarBtn) requestCarBtn.disabled = true;
    if((this.state.booking && this.state.booking.car_requested == "true") || this.state.carRequested){
      if(requestCarBtn) requestCarBtn.disabled = false;
      return;
    } 
    fetch(`${this.baseUrl}/parking/valet/vehicle/request?valet_booking_id=${this.state.booking ? this.state.booking.id : ''}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            this.setState({ 
              carRequested: true,
              isPayRequestCar: false
            }, () => { 
              if(requestCarBtn) requestCarBtn.disabled = false;
            });
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            if(requestCarBtn) requestCarBtn.disabled = false
            toast.dismiss();
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          if(requestCarBtn) requestCarBtn.disabled = false
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  removeCoupon(){
    this.setState({loading: true})
    fetch(`${this.baseUrl}/parking/valet/hash/${this.state.bookingId}/remove-coupon`, {
      method: 'PUT',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({coupon_code: this.state.fields["coupon"]})
     }).then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            let fields = this.state.fields;
            fields["coupon"] = '';
            const isFreeParking = this.deduceFreeParking(resp.data);
            this.setState({ 
              fields,
              couponApplied: false,
              discountAmount: resp.data.discount_amount ? resp.data.discount_amount : 0,
              booking: resp.data,
              loading: false,
              isFreeParking
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            this.setState({loading: false});
            toast.dismiss();
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          this.setState({loading: false});
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  validateCoupon(){
    if(!this.state.fields['coupon']) return;
    let couponApplyBtn = document.querySelector('.coupon-apply');
    couponApplyBtn.disabled = true;
    if(this.state.couponApplied){
      this.removeCoupon();
      couponApplyBtn.disabled = false;
      this.setState({loading : false});
      return;
    }
    if(!this.state.booking) return;
    let {booking_start_time, booking_end_time, parking_fee, convenience_fee, parking_id} = this.state.booking;
    if(!booking_start_time || !booking_end_time || !convenience_fee || !parking_id){
      couponApplyBtn.disabled = false;
      this.setState({loading : false});
      return;
    } 
    this.setState({loading : true});
    const startDateTime = moment(booking_start_time, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const endDateTime = moment(booking_end_time, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    let request = {
      start_date_time: startDateTime,
      end_date_time: endDateTime,
      coupon_code: this.state.fields['coupon'] ? [this.state.fields['coupon']] : [],
      tip_amount: this.state.tipAmount ? this.state.tipAmount : 0,
      parking_fee: parking_fee,
      convenience_fee: convenience_fee,
      parking_id: parking_id,
      is_valet: true
    };
    fetch(`${this.baseUrl}/parking/valet/hash/${this.state.bookingId}/apply-coupon`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
          if(resp?.data?.length && resp.status === "SUCCESS"){
            this.getBookingDetails(true);
            couponApplyBtn.disabled = false;
          }else{
            let fields = this.state.fields;
            fields["coupon"] = '';
            this.setState({
              couponApplied: false,
              discountAmount: 0,
              fields,
              loading: false
            }, () =>  couponApplyBtn.disabled = false)  
            let errMsg = resp.error && resp.error.reason ? resp.error.reason.includes("isValet is false") ? 'Invalid coupon' : resp.error.reason : 'Something went wrong'; 
            toast.dismiss();
            toast.error(errMsg, { autoClose: resp.error && resp.error.reason ? 10000 : 2000 });
          }
        })
        .catch((error) => {
          this.setState({loading : false}, () =>  couponApplyBtn.disabled = false)
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

   emailReceipt(id){
    if(!document.querySelector('#email').value){
      return;
    }
    fetch(`${this.baseUrl}/parking/valet/payment/receipt?valet_booking_id=${id}&email=${document.querySelector('#email').value}`)
    .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            this.setState({
              emailSent: true
            }) 
          }else{
            toast.dismiss();
            toast.error('Something went wrong');
          }
        })
        .catch((error) => {
          toast.dismiss();
          toast.error('Something went wrong');
        });
  } 

  handleChange(e) {
    let fields = {...this.state.fields};
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });
  }

  nonSpecialCharacter(name){
      let fields = this.state.fields;
      return !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(fields[name]);
  }

  onlyZip(name){
    let fields = this.state.fields;
    if(!fields[name].match(/^[0-9]{5}$/)){
      return false;
    }
    return true;
  }

  onlyPhone(name){
    let fields = this.state.fields;
    if(!fields[name].match(/^[0-9]*$/)){
      return false;
    }
    return true;
  }

  onlyEmail(name){
    let fields = this.state.fields;
    if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(fields[name])){
      return false;
    }
    return true;
  }

  handleTip(e){
    if(!e.target.classList.contains("active")){
      document.querySelectorAll('.tip-label-btn').forEach(item => item.classList.remove("active"));
      document.querySelector('#other_amount').value = '';
      e.target.classList.add("active");
      this.setState({
        tipAmount: parseFloat(e.target.value)
      })
    }else{
      if(this.state.isNoTipBtn) return;
      e.target.classList.remove("active");
      this.setState({
        tipAmount: 0
      })
    }
  }

  /* handleTip(e){
    if(e.target.className != "active"){
      let arrOfId = e.target.getAttribute('data-sibling-id').split('#');
      arrOfId.forEach(item => document.querySelector('#' + item) ? document.querySelector('#' + item).classList.remove('active') : false);
      document.querySelector('#other_amount').value = '';
      e.target.classList.add("active");
      this.setState({
        tipAmount: parseFloat(e.target.value)
      })
    }else{
      if(this.state.isNoTipBtn) return;
      e.target.classList.remove("active");
      this.setState({
        tipAmount: 0
      })
    }
  } */

  handleTipInput(e){
    if(e.target.value < 0){
      toast.dismiss();
      toast.error('Invalid tip amount');
      document.querySelector('#other_amount').value = '';
    }
    document.querySelectorAll('.tip-label-btn').forEach(item => item.classList.remove("active"));
    let hasValue = e.target.value >= 0;
    this.setState({
      tipAmount: hasValue ? parseFloat(e.target.value) : 0
    }, () => {
      if(!hasValue){
        document.querySelector('#other_amount').value = '';
        if(this.state.isNoTipBtn) document.querySelectorAll('.tip-label-btn')[0].classList.add('active');
      }
    })
  }

  handlePercentTip(e){
    if(e.target.className != "active"){
      let parkingFee = this.state.booking && this.state.booking.parking_fee ? this.state.booking.parking_fee/100 : 0;
      let arrOfId = e.target.getAttribute('data-sibling-id').split('#');
      arrOfId.forEach(item => document.querySelector('#' + item).classList.remove('active'));
      document.querySelector('#other_per_amount').value = '';
      e.target.classList.add("active");
      this.setState({
        tipAmount: (parseFloat(e.target.value)/100) * parkingFee
      })
    }else{
      e.target.classList.remove("active");
      this.setState({
        tipAmount: 0
      })
    }
  }

  handlePercentTipInput(e){
    if(e.target.value < 0){
      toast.dismiss();
      toast.error('Invalid tip amount');
      document.querySelector('#other_per_amount').value = '';
    }
    let parkingFee = this.state.booking && this.state.booking.parking_fee ? this.state.booking.parking_fee/100 : 0;
    [1,2,3].forEach(item => document.querySelector('#tip-per-btn' + item).classList.remove('active'));
    let hasValue = e.target.value >= 0;
    this.setState({
      tipAmount: hasValue ? parseFloat(e.target.value) : 0
    }, () => {
      if(!hasValue){
        document.querySelector('#other_per_amount').value = '';
      } 
    })
  }

  initForm(){
    this.getBookingDetails();
    this.stripe = window.Stripe(this.stripeKey);
    var elements = this.stripe.elements();

    var style = {
      base: {
        iconColor: '#666EE8',
        color: '#000',
        lineHeight: '40px',
        fontSize: '16px',
    
        '::placeholder': {
          color: '#000',
          fontWeight: 300,
          fontSize: '13px'
        },
      },
    };

    this.paymentRequest = this.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: '',
        amount: this.state.totalFee ? this.state.totalFee : 0
      },
      requestPayerName: true
    });

    var elements = this.stripe.elements();
    this.payRequestButton = elements.create('paymentRequestButton', {
      paymentRequest: this.paymentRequest
    });

    
    this.paymentRequest.canMakePayment().then((result) => {
      this.checkIfAppleGooglePayOption(result);
    });

    this.payRequestButton.on('click', (event) => {
      this.handlePayRequestButtonClick(event);
    });

    this.paymentRequest.on('paymentmethod', (ev) => {
      this.onPaymentRequestStart(ev);
    });
    
    this.card = elements.create('card', {style: style, hidePostalCode: false});

    this.card.mount('#card-element');

    this.card.addEventListener('change', function(event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  checkIfAppleGooglePayOption(result){
    if (result) {
      this.setState({
        walletType: result.applePay ? 'applePay' : result.googlePay ? 'googlePay' : ''
      },() => {
        document.getElementById('partners-button').style.display = 'block';
        this.payRequestButton.mount('#payment-request-button');
      })
     
    } else {
      document.getElementById('payment-request-button').style.display = 'none';
    }
  }

  handlePayRequestButtonClick(event){
    if(this.state.loading) return;
    const isValid = this.validateForm(false);
    if(!isValid) {
      event.preventDefault();
      return;
    }
    let info = this.state.booking && this.state.booking.parking_charge ? this.state.booking : 0;
    if(!info) return;
    let tipConvFee = info.valet_conv_fee_rate && info.valet_conv_fee_rate.tip_conv_fee_percent ? info.valet_conv_fee_rate.tip_conv_fee_percent : 0;
    let totalAmt = info.parking_charge;
    if(tipConvFee && this.state.tipAmount){
      totalAmt = (totalAmt + (this.state.tipAmount * 100) + (tipConvFee * (this.state.tipAmount * 100)));
    }
    if(this.state.applyCouponTriggered){
      totalAmt = totalAmt - this.state.discountAmount;
    } 
    this.paymentRequest.update({
      total: {
        label: '',
        amount: totalAmt && totalAmt > 0 ? totalAmt : 0
      }
    });
  }

  onPaymentRequestStart(ev){
    let payErrorMsg = '';
    let request = this.prepareRequest('', ev.paymentMethod.id, '', '', '',  this.state.walletType);
    delete request.payment_details;

    fetch(this.state.isFreeParking && this.state.isV2API ? `${this.baseUrl}/parking/valet/tip/payment/authenticate` : `${this.baseUrl}/parking/valet/payment/web/authenticate`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
      })
    .then(response => response.json())
    .then(resp => {
        if(resp.data && resp.status === "SUCCESS" && resp.data.status === 'succeeded'){
          this.handleSubmit('', '', ev.paymentMethod.id, resp.data.customer, resp.data.payment_intent, resp.data.charge_id, ev, this.state.walletType);
        }else if(resp.data && resp.status === "SUCCESS" && resp.data.status === 'requires_action'){
          this.stripe
              .confirmCardPayment(resp.data.client_secret)
              .then((ccp) => {
                if(ccp.error){
                  ev.complete('fail');
                  payErrorMsg = ccp && ccp.error && ccp.error.message ? ccp.error.message : 'Something went wrong';
                  payErrorMsg = getStripeError(payErrorMsg);
                  this.openErrorModal(payErrorMsg);
                }else{
                  this.handleSubmit('', '', ev.paymentMethod.id, resp.data.customer, resp.data.payment_intent, resp.data.charge_id, ev, this.state.walletType);
                }
              });
        }else{
          ev.complete('fail');
          payErrorMsg = getStripeError('');
          this.openErrorModal(payErrorMsg);
        }
      })
      .catch((error) => {
        ev.complete('fail');
        payErrorMsg = getStripeError('');
        this.openErrorModal(payErrorMsg);
    });
  }

  openErrorModal(payErrorMsg){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.manageBodyBackground(true);
    this.setState({payErrorMsg});
  }

  setOutcome(result, req) {
    const submitBtn = document.getElementById("pay-submit");
    let payErrorMsg = '';
    if (result && result.paymentMethod && result.paymentMethod.id) {
      let request = this.prepareRequest('', result.paymentMethod.id);
      delete request.payment_details;
      fetch(this.state.isFreeParking && this.state.isV2API ? `${this.baseUrl}/parking/valet/tip/payment/authenticate` : `${this.baseUrl}/parking/valet/payment/web/authenticate`, {
        method: 'post',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(request)
       })
      .then(response => response.json())
      .then(resp => {
          if(resp.data && resp.status === "SUCCESS" && resp.data.status === 'succeeded'){
            this.handleSubmit('', this.card, result.paymentMethod.id, resp.data.customer, resp.data.payment_intent, resp.data.charge_id)
          }else if(resp.data && resp.status === "SUCCESS" && resp.data.status === 'requires_action'){
            this.stripe
              .confirmCardPayment(resp.data.client_secret, {
                payment_method: req
              })
              .then((ccp) => {
                if(ccp.error){
                  this.setState({loading : false});
                  payErrorMsg = ccp && ccp.error && ccp.error.message ? ccp.error.message : 'Something went wrong';
                  payErrorMsg = getStripeError(payErrorMsg);
                  this.openErrorModal(payErrorMsg);
                  submitBtn.disabled = false;
                }else{
                  this.handleSubmit('', this.card, result.paymentMethod.id, resp.data.customer, resp.data.payment_intent, resp.data.charge_id)
                }
              });
          }else{
            this.setState({loading : false});
            payErrorMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
            payErrorMsg = getStripeError(payErrorMsg);
            this.openErrorModal(payErrorMsg);
            submitBtn.disabled = false;
          }
        })
        .catch((error) => {
          this.setState({loading : false});
          payErrorMsg = getStripeError('');
          this.openErrorModal(payErrorMsg);
          submitBtn.disabled = false;
      });
    } else if (result.error) {
      this.setState({loading : false});
      payErrorMsg = result.error.message ? result.error.message : 'Something went wrong';
      payErrorMsg = getStripeError(payErrorMsg);
      this.openErrorModal(payErrorMsg);
      submitBtn.disabled = false;
    }
  }

  validateForm(isCard){
    let fields = this.state.fields;
    let formIsValid = true;
    this.errors = {};
    const cardWrapper = document.querySelector('#card-element');
    const cardWrapperError = document.querySelector('#card-errors');
    // let isPayment = this.state.couponApplied ? false : true;
    
    if(isCard){
      if(cardWrapper.classList.contains('StripeElement--empty')){
        formIsValid = false;
        cardWrapperError.innerHTML = "enter your card number";
      }
      if(cardWrapper.classList.contains('StripeElement--invalid')){
        formIsValid = false;
        if(!cardWrapperError.innerHTML.trim()) cardWrapperError.innerHTML = "enter valid details";
      }
      if (!fields["cardholder_name"] || (fields["cardholder_name"] && fields["cardholder_name"].trim() === '')) {
        formIsValid = false;
        this.errors["cardholder_name"] = "enter the cardholder name";
      }
    }else if(cardWrapperError && this.card){
      cardWrapperError.innerHTML = "";
      this.card.clear();
    }

    this.setState({
      errors: this.errors
    });
    return formIsValid;
  }

  prepareRequest(id, paymentMethodId, customerId, paymentIntent, chargeId, walletType){
    const { fields, booking } = this.state;
    const request = {
      apple_pay: walletType === 'applePay' ? true : false,
      google_pay: walletType === 'googlePay' ? true : false,
      valet_booking_id: booking.id,
      tip_amount: this.state.tipAmount ? parseFloat(this.state.tipAmount * 100) : 0,
      source_id: id,
      email: '',
      contact_number: booking.contact_number,
      country_code: booking.country_code,
      parking_id: booking.parking_id,
      cardholder_name: fields["cardholder_name"] ? fields["cardholder_name"] : '',
      coupon_code: fields.coupon ? fields.coupon : '',
      first_name: booking.first_name ? booking.first_name : '',
      last_name: booking.last_name ? booking.last_name : '',
      payment_method_id: paymentMethodId ? paymentMethodId : '',
      payment_details: { 
        customer: customerId ? customerId : '',
        payment_intent: paymentIntent ? paymentIntent : '',
        charge_id: chargeId ? chargeId : ''
      }
    }
    return request;
  }

  preSubmit(total){
    document.getElementById("pay-submit").disabled =  true;
    if(this.state.loading) return;
    if(!total){
      document.getElementById("pay-submit").disabled =  false;
      toast.dismiss();
      toast.error('Invalid Amount $0.00');
      return;
    }
    const submitBtn = document.getElementById("pay-submit");
    const isValid = this.validateForm(true);
    if(!isValid) {
      submitBtn.disabled = false;
      return;
    }
    if(this.state.isFreeParking && !this.state.tipAmount){
      submitBtn.disabled = false;
      return;
    }
    let isPayment = this.state.couponApplied && this.state.totalFee === 0 ? false : true;
    this.manageBodyBackground(true);
    this.setState({loading : true});
    if(isPayment){
      const { fields } = this.state;
      let contactNumber = fields.mobile ? fields.mobile.trim() : '';
      let countryCode = fields.areaCode ? '+' + fields.areaCode : '';
      var options = {
        name: fields.cardholder_name,
        phone: countryCode +' '+ contactNumber,
      };
      if(fields.email){
        options.email = fields.email ? fields.email.trim() : ''
      }
      let req = {
        type: 'card',
        card: this.card,
        billing_details: {
          name: fields.cardholder_name,
          phone: countryCode +' '+ contactNumber
        }
      }
      this.stripe.createPaymentMethod(req).then((result) => this.setOutcome(result, req));
    }else{
      this.handleSubmit('', this.card);
    }
  }

  handleInitQRScan(value){
    if(value) window.scrollTo(0,0);
    this.setState({
      isQRScan: value
    })
  }

  handleQRScanError = () => {
    this.setState({
      isQRScan: false
    }, () => {
      toast.error('Invalid QR Scan');
      this.stopScanResult = false;
    })
  }

  handleQRCodeScanResult = (result, error) => {
    if (result && result.text) {
      if(this.stopScanResult) return;
      this.stopScanResult = true;
      let campaign;
      if(result.text) {
        try {
          campaign = JSON.parse(result.text);
        } catch(e) {
          this.handleQRScanError(campaign);
          return;
        }
      }else{
        this.handleQRScanError(campaign);
        return;
      }
      if(!campaign || !campaign.token){
        this.handleQRScanError(campaign);
        return;
      }
      this.setState({loading: true, isQRScan: false});
      fetch(`${this.baseUrl}/parking/campaign/coupon?parking_id=${this.state.parkingId}&coupon_code=${campaign.token}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS" && resp.data.coupon_code){
            this.setState({
              isQRScan: false,
              fields:{
                ...this.state.fields,
                coupon: resp.data.coupon_code
              }
            }, () => {
              this.stopScanResult = false;
              this.validateCoupon();
            })
          }else{
              this.setState({loading: false});
              this.stopScanResult = false;
              toast.error('Something went wrong');
          }
        })
        .catch((error) => {
           this.setState({loading: false});
            this.stopScanResult = false;
            toast.error('Something went wrong');
        });
    }

    if (error) {
    }
  }

  handleCalendarScheduleCar(){
    const combinedDateTime = moment(this.state.selectedDate)
    .set({
      hours: this.state.selectedTime._d.getHours(),
      minutes: this.state.selectedTime._d.getMinutes(),
      seconds: this.state.selectedTime._d.getSeconds(),
    });
    const epochTimeInMilliseconds = combinedDateTime.valueOf();
    var myHeaders = new Headers();
    myHeaders.append("device_os", "web");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("user_id", `${this?.state?.booking.external_user_id}` );
    var raw = JSON.stringify({
      "schedule_time": epochTimeInMilliseconds,
      "repeating": false,
      "vehicle_no": this?.state?.booking.vehicle_no,
      "parking_id": this.state.parkingId,
      "schedule_id": null
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    this.setState({loading: true})
    fetch(`${this.baseUrl}/parking/valet/vehicle/request/schedule`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const parsedResult = JSON.parse(result);
        if (parsedResult.status === "SUCCESS") {
            this.handleCloseCarRequestedPopUp();
            this.getBookingDetails();
            this.setState({loading: false});
            toast.success('Scheduled successfully')
        }else{
        this.setState({loading: false});
        toast.error('Something went wrong')
        }
    })
      .catch(error =>{
        this.setState({loading: false});
        toast.dismiss();
        toast.error('Something went wrong')
      });
  }
  
  getCarRequestedList(data, requestType = null) {
    var myHeaders = new Headers();
    myHeaders.append("user_id", `${data}`);
    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    this.setState({loading: true})
    fetch(`${this.baseUrl}/parking/valet/vehicle/request/schedule`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result && result.data && result.data.car_request_schedules && result.status === "SUCCESS") {
              const allSchedules = result.data.car_request_schedules;
              const matchingSchedules = allSchedules.filter(schedule => schedule.vehicle_number === this.state.booking.vehicle_no);
              this.setState({requestList: matchingSchedules})
                const schedules = matchingSchedules;
                const currentTime = moment().tz(this?.state?.timeZone);
                const futureSchedules = schedules.filter(schedule => moment(schedule.schedule_time).tz(this?.state?.timeZone)?.isAfter(currentTime));
                futureSchedules.sort((a, b) =>  moment(a.schedule_time).valueOf() - moment(b.schedule_time).valueOf());
                schedules.filter((ele) => {
                  const scheduleTime = moment(ele.schedule_time).tz(this?.state?.timeZone);
                  if (scheduleTime?.isSameOrAfter(currentTime)) {
                      this.setState({displayUpcoming: true})
                  }
                  // if (scheduleTime?.isBefore(currentTime)) {
                  //   this.setState({displayPast: true})
                  // }
              })
                if (futureSchedules.length > 0) {
                    const lowestScheduleTime = futureSchedules[0].schedule_time;
                    const scheduledTime = moment(lowestScheduleTime).format('MMM DD, YYYY, hh:mm A');
                    this.setState({scheduledCarReqTime: scheduledTime})
                } else {
                    this.setState({scheduledCarReqTime: '', displayUpcoming: false})
                }
                this.setState({loading: false})
            } else {
                this.setState({loading: false});
                toast.error('Something went wrong')
            }
        })
        .catch(error => {
          this.setState({loading: false});
          toast.dismiss();
          toast.error('Something went wrong')
        });
}

  cancelCarRequest(e, data) {
    e.preventDefault()
    var myHeaders = new Headers();
    myHeaders.append("user_id", `${data.external_user_id}`);
    myHeaders.append("device_os", "web");
    myHeaders.append("Content-Type", "application/json")

    var raw = JSON.stringify({
      "schedule_id": data.id,
      "cancel_all": false
    });

    var requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      body: raw,
    };
    this.setState({loading: true})
    fetch(`${this.baseUrl}/parking/valet/vehicle/request/cancel`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const parsedResult = JSON.parse(result);
        if (parsedResult.status === "SUCCESS") {
        this.getCarRequestedList(data.external_user_id)
        this.setState({loading: false});
        toast.success('Cancelled successfully')
      }else{
        this.setState({loading: false});
          toast.dismiss();
          toast.error('Something went wrong')
      }})
      .catch(error => {
        this.setState({loading: false});
          toast.dismiss();
          toast.error('Something went wrong')
      });
  }

  handleSubmit(id, card, paymentMethodId, customerId, paymentIntent, chargeId, btnEvent, walletType){
    let payErrorMsg = '';
    const submitBtn = document.getElementById("pay-submit");
    let request = this.prepareRequest(id, paymentMethodId, customerId, paymentIntent, chargeId, walletType);
    fetch(this.state.isFreeParking && this.state.isV2API ?  `${this.baseUrl}/parking/valet/tip/payment/capture` : `${this.baseUrl}/parking/valet/web/payment`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
        if(resp.data && resp.status === "SUCCESS"){
          window.scrollTo(0,0);
          const paymentStatus = resp.data?.payment_status;
          const isPartialPaid = paymentStatus === "partial_paid";
          const isOnlyPaid = paymentStatus === 'paid';
          this.setState({...this.resetState, paidDetails: resp.data, showPaymentDetails: false, loading: false, hidePayBtn: true, isPartialPaid, isOnlyPaid}, () => {
            this.manageBodyBackground(false);
            if(card) card.clear();
            if(btnEvent)  btnEvent.complete('success');
            toast.dismiss();
            toast.success('Payment successful');
            submitBtn.disabled = false;
            if(this.state.isPayRequestCar) this.requestCar();
          });
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
          if(btnEvent)  btnEvent.complete('fail');
          this.setState({loading : false});
          payErrorMsg = getStripeError(errMsg);
          this.openErrorModal(payErrorMsg);
          submitBtn.disabled = false;
        }
      })
      .catch((error) => {
        if(btnEvent)  btnEvent.complete('fail');
        this.setState({loading : false});
        payErrorMsg = getStripeError('');
        this.openErrorModal(payErrorMsg);
        submitBtn.disabled = false;
      });  
  }

  handleFocus(name){
    document.querySelector(`input[name="${name}"]`).focus();
    return false;
  }

  handleFocusSp(name){
    document.querySelector(`select[name="${name}"]`).focus();
    return false;
  }

  handleClose(){
    this.setState({booked: false, bookedID: null }, () => {
      this.manageBodyBackground(false);
    })
  }

  handleErrorModalClose(){
    this.setState({payErrorMsg: false }, () => {
      this.manageBodyBackground(false);
    })
  }

  showPaymentDetails(){
    this.setState({
      showPaymentDetails: !this.state.showPaymentDetails,
      hidePayBtn: this.state.showPaymentDetails
    })
  }

  showPaidDetails(){
    this.setState({
      showPaidDetails: !this.state.showPaidDetails
    })
  }

  carRequested(){
    this.setState({
      carRequested: true
    })
  }

  handleNameChange(e, name){
    let keyUpdate = this.state.paidDetails ? 'paidDetails' : 'booking';
    this.setState({
      [keyUpdate]: {
        ...this.state[keyUpdate],
        [name]: e.target.value
      }
    })
  }

  getBtnLabel(obj, total, isCheckout){
    let label = '';
    let discountedAmount;
    if(obj.discount_amount && !this.state.isFreeParking){
        discountedAmount = obj.parking_fee - obj.discount_amount;
        if(discountedAmount < 0) discountedAmount = 0;
    }
    if(isCheckout && !this.state.isFreeParking && !this.state.isPayRequestCar){
      let value = discountedAmount ? (discountedAmount/100) : (obj.parking_fee/100).toFixed(2);
      label = 'Checkout $' + value;
    }else if(this.state.isPayRequestCar && !this.state.isFreeParking){
      label = 'Pay & Request Your Car';
    }else if(this.state.isFreeParking){
      label = 'Pay Tip';
    }else if(total){
      label = 'Pay $' + (total/100).toFixed(2);
    }else{
      label = '';
    }
    return label;
  }

  handlePastRequestsClick = (e) => {
    e.preventDefault();
    this.setState({requestType: PAST_REQUEST})
    this.getCarRequestedList(this.state.user_id);
  };

  handleUpcomingRequestsClick = (e) => {
    e.preventDefault();
    this.setState({requestType: UPCOMING_REQUEST})
    this.getCarRequestedList(this.state.user_id);
  };

  render() {
    const maxDate =  moment.unix(this?.state?.checkout_date/1000).tz(this?.state?.timeZone)?.format('MM/DD/YYYY')
    let isPayment = this.state.couponApplied && this.state.totalFee === 0 ? false : true;
    let info = this.state.paidDetails && this.state.paidDetails.payment_status ? this.state.paidDetails : this.state.booking;
    let convFeeRates = info.valet_conv_fee_rate && info.valet_conv_fee_rate ? info.valet_conv_fee_rate : null;
    let convFeeFixed = info.convenience_fee && info.payment_status != "paid" ? info.convenience_fee : this.state.tipAmount && convFeeRates ? convFeeRates.fixed_conv_fee : 0;
    let convFee = convFeeFixed;
    let total = info.parking_charge;
    let tipConvFee = convFeeRates && convFeeRates.tip_conv_fee_percent ? convFeeRates.tip_conv_fee_percent : 0;
    if(tipConvFee && this.state.tipAmount){
      if(total <= 0 || !total){
        total = 0;
        total = (this.state.tipAmount * 100) + (tipConvFee * (this.state.tipAmount * 100)) + convFeeFixed;
      }else{
        total = (total + (this.state.tipAmount * 100) + (tipConvFee * (this.state.tipAmount * 100)));
      }
      convFee = convFeeFixed + (tipConvFee * (this.state.tipAmount * 100));
    }
    if(this.state.applyCouponTriggered){
      total = info.parking_charge - this.state.discountAmount;
      if(total <= 0){
        total = 0;
        if(tipConvFee && this.state.tipAmount){
          total = (this.state.tipAmount * 100) + (tipConvFee * (this.state.tipAmount * 100)) + convFeeFixed;
        }
      }
    }
    if((total <= 0 && convFee) || (total === convFee)){
      convFee = 0;
    }
    if((total <= 0)){
      total = 0;
    }
    return (
      <div style={{position: 'relative', marginBottom: '20px'}}>
        {(this.state.loading || this.state.payErrorMsg) && <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10}}></div>}
        {this.state.loading && <div className="loader">Loading...</div>}
        <div style={{display: this.state.booked ? 'block' : 'none'}} className="success-message">
          <span onClick={this.handleClose.bind(this)} id="sm-close">&times;</span>
          <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
            <circle cx="38" cy="38" r="36"></circle>
            <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
          </svg>
          <h3 className="success-message__title">Booked Successfully</h3>
          <div className="success-message__content">
              <p>Booking Id: {this.state.bookingID}</p>
          </div>
        </div>
        <div style={{ display: this.state.showCarRequestedPopUp ? 'block' : 'none' }} className='car-requested-popup'>
          <span onClick={this.handleCloseCarRequestedPopUp.bind(this)} id="sm-close">&times;</span>
          <div className='calender-div'>
            <DatePicker
            selected={this.state.selectedDate}
              inline
              minDate={moment().toDate()}
              maxDate={maxDate ? moment(maxDate, "MM/DD/YYYY").toDate() : moment().toDate() }
            dateFormat="MMM dd, yyyy"
            onChange={(data) => this.handleCalendarDateChange(data)} 
            />
          </div>
          <div className="calendar-popup-time-picker">
            <TimePicker
            defaultOpenValue={moment().hour(0).minute(0)}
              showSecond={false}
              value={this.state.selectedTime}
              onChange={(data) => this.setState({selectedTime: data})}
              format={"hh:mm a"}
              use12Hours
              inputReadOnly
            />
            <div className='calendar-popup-buttons'>
              <button className='calendar-popup-close-btn' onClick={this.handleCloseCarRequestedPopUp.bind(this)}>Close</button>
              <button className='calendar-popup-save-btn'id='schedule-car'onClick={this.handleCalendarScheduleCar}>Schedule</button>
            </div>
          </div>
        </div>
        <div style={{display: this.state.payErrorMsg ? 'block' : 'none'}} className="error-message">
          <span onClick={this.handleErrorModalClose.bind(this)} id="sm-close">&times;</span>
          <svg fill="#FF0000" viewBox="0 0 478.125 478.125" xmlSpace="preserve" className="error-message__icon icon-checkmark">
            <g>
              <g>
                <g>
                  <circle cx="239.904" cy="314.721" r="35.878" />
                  <path d="M256.657,127.525h-31.9c-10.557,0-19.125,8.645-19.125,19.125v101.975c0,10.48,8.645,19.125,19.125,19.125h31.9
                  c10.48,0,19.125-8.645,19.125-19.125V146.65C275.782,136.17,267.138,127.525,256.657,127.525z" />
                  <path d="M239.062,0C106.947,0,0,106.947,0,239.062s106.947,239.062,239.062,239.062c132.115,0,239.062-106.947,239.062-239.062
                  S371.178,0,239.062,0z M239.292,409.734c-94.171,0-170.595-76.348-170.595-170.596c0-94.248,76.347-170.595,170.595-170.595
                  s170.595,76.347,170.595,170.595C409.887,333.387,333.464,409.734,239.292,409.734z" />
                </g>
              </g>
            </g>
          </svg>
          <div className="error-message__content">
             <p>{this.state.payErrorMsg}</p>
          </div>
        </div>
        <form style={{pointerEvents: this.state.booked || this.state.seeMore ? 'none' : 'auto'}} action="#" method="POST">
          <input type="hidden" name="token" />
          <div style={{textAlign: 'center', paddingBottom: 20}}>
            <img style={{height: 85}} src="https://portal.parkquility.com/public/pq_logo.png" />
          </div>
          <div style={{textAlign: 'center'}} className="location">
            <img style={{height: 35}} src={gpsIcon} /> 
            <span>{info.arena_name}</span>
          </div>
          <p style={{paddingTop: 10, paddingBottom: 10, color: '#333'}}>Please update your information and make payment for the Valet service</p>
          <h4 style={{paddingBottom: 10}}>Reservation Summary</h4>
          <ul className="pay-timings">
            <li>
              <span className="list-initial">Booking Id</span>
              <span>{info.employee === 'true' ? 'E-' : 'C-'}{info.id} - {info.keyboard_slot}</span>
            </li>
            <li>
              <span className="list-initial">Mobile Number</span>
              <span>{info.contact_number === "1111111111" ? '' : `${info.country_code}-${info.contact_number}`}</span>
            </li>
            <li>
              <span className="list-initial">License Plate</span>
              <span>{info.vehicle_no}</span>
            </li>
            <li>
              <span className="list-initial">Start Time</span>
              <span>{info.booking_start_time}</span>
            </li>
            <li>
              <span className="list-initial">End Time</span>
              <span>{info.booking_end_time}</span>
            </li>
            {this.state.scheduledCarReqTime && <li>
              <span className="list-initial">Scheduled Car Request</span>
              <span>{this.state.scheduledCarReqTime}</span>
            </li>}
            {info.payment_status === 'paid' && info.payment_type && <li>
              <span className="list-initial">Payment Type</span>
              <span style={{textTransform: 'capitalize'}}>{info.payment_type.replace("_", " ")}</span>
            </li>}
          </ul>
          <div className={!this.state.showPaymentDetails ? 'pay-collapsed ' : 'pay-open fade'}>
            <h4 style={{paddingTop: 10, paddingBottom: 10}}>Payment</h4>
            <ul className="pay-timings">
              <li>
                <span className="list-initial">Name</span>
                <span className='name-edit'><input onChange={(e) => this.handleNameChange(e, 'first_name')} placeholder='First Name'  type="text" value={info.first_name}/> <input onChange={(e) => this.handleNameChange(e, 'last_name')} placeholder='Last Name' style={{marginLeft: '2%'}} type="text" value={info.last_name}/></span>
                {/* <span>{info.first_name} {info.last_name}</span> */}
              </li>
              {info.email && <li>
                <span className="list-initial">Email</span>
                <span>{info.email}</span>
              </li>}
              {info.parking_fee > 0 && <li>
                <span className="list-initial">Parking fee</span>
                <span>${info.parking_fee ? (info.parking_fee/100).toFixed(2) : ''}</span>
              </li>}
              {info.paid_amount > 0 && <li>
                <span className="list-initial">Partial payment</span>
                <span>${info.paid_amount ? (info.paid_amount/100).toFixed(2) : ''}</span>
              </li>}
              {info.validation_amount > 0 && <li>
                <span className="list-initial">Validation amount</span>
                <span>${info.validation_amount && info.validation_amount > info.parking_fee ? (info.parking_fee/100).toFixed(2) : info.validation_amount ? (info.validation_amount/100).toFixed(2) : ''}</span>
              </li>}
              {this.state.discountAmount > 0 && <li>
                <span className="list-initial">Discount amount</span>
                <span>${this.state.discountAmount && this.state.discountAmount > info.parking_fee ? (info.parking_fee/100).toFixed(2) : this.state.discountAmount ? (this.state.discountAmount/100).toFixed(2) : ''}</span>
              </li>}
            </ul>
            {!this.state.isTipPercent &&
              <>
                  <ul className="pay-timings add-tip">
                    {!this.state.tipConfig?.is_only_custom_input && <li>
                      <span style={{ fontWeight: 'bold', fontSize: '14px' }} className="list-initial">Add Tip</span>
                      <span>
                        {this.state.isNoTipBtn && <button className='active tip-label-btn' style={{ width: '55px' }} type="button" value={0} onClick={this.handleTip.bind(this)}>No Tip</button>}
                        {this.state.tipConfig?.amount_labels?.map((item, index) => <button key={`tip-label-btn-${index}`} className={this.state.tipConfig.default_tip_amount === item ? 'active tip-label-btn' : 'tip-label-btn'} type="button" value={item} onClick={this.handleTip.bind(this)}>${item}</button>)}
                      </span>                 
                    </li>}
                    <li>
                      {this.state.tipConfig?.is_only_custom_input ? <span style={{ fontWeight: 'bold', fontSize: '14px' }} className="list-initial">Add Tip</span> : <span></span>}
                      <span><input id="other_amount" type="number" style={{ textAlign: 'center' }} onChange={this.handleTipInput.bind(this)} placeholder='Other Amount' /></span>
                    </li>
                  </ul>
              </>
            }
            {this.state.isTipPercent && <ul className="pay-timings add-tip">
              <li>
                <span style={{fontWeight: 'bold', fontSize: '14px'}} className="list-initial">Add Tip</span>
                <span>
                  <button className='active' id="tip-per-btn1" data-sibling-id="tip-per-btn2#tip-per-btn3" type="button" value={18} onClick={this.handlePercentTip.bind(this)}>18%</button>
                  <button id="tip-per-btn2" data-sibling-id="tip-per-btn1#tip-per-btn3" type="button" value={25} onClick={this.handlePercentTip.bind(this)}>25%</button>
                  <button id="tip-per-btn3" data-sibling-id="tip-per-btn1#tip-per-btn2" type="button" value={33} onClick={this.handlePercentTip.bind(this)}>33%</button>
                </span>
              </li>
              <li>
                <span></span>
                <span><input id="other_per_amount" type="number" style={{textAlign: 'center'}} onChange={this.handlePercentTipInput.bind(this)} placeholder='Other Amount' /></span>
              </li>
            </ul>}
            {!this.state.tipConfig?.is_only_custom_input && <p style={{color: '#333', paddingTop: '10px'}}>Complete TIP goes to your hardworking Valet. Please be generous.</p>}
            <ul className='pay-timings' style={{marginTop: '15px'}}>
              <li>
                <span style={{fontWeight: 'bold', fontSize: '12px'}} className="list-initial">{this.state.parkingId !== 5882 ?'Convenience fee':'Card fee'}</span>
                <span style={{fontWeight: 600, fontSize: '14px'}}>{convFee ? '$' + (convFee/100).toFixed(2) : '$0.00'}</span>
              </li>
              {info.parking_fee > 0 && <li>
                <span style={{fontWeight: 'bold', fontSize: '12px'}} className="list-initial">Tip Amount</span>
                <span style={{fontWeight: 600, fontSize: '14px'}}>{this.state.tipAmount ? '$' + this.state.tipAmount.toFixed(2) : '$0.00'}</span>
              </li>}
              <li>
                <span style={{fontWeight: 'bold', fontSize: '14px'}} className="list-initial">{info.parking_fee > 0 ? "Total Fee" : "Total Tip"}</span>
                <span style={{fontWeight: 600, fontSize: '18px'}}>{total ? '$'+(total/100).toFixed(2) : '$0.00'}</span>
              </li>
            </ul> 
            {!this.state.isHideApplyCoupon && <div style={{position: 'relative'}} class="upper">
              <span onClick={() => this.handleFocus('coupon')} style={{fontWeight: 'bold', fontSize: '14px'}}>Apply Coupon</span>
              <div className='apply-coupon-wrap'>
                <input
                  disabled={this.state.couponApplied}
                  className="pay-fields" 
                  value={this.state.fields["coupon"]}
                  name="coupon"
                  onChange={this.handleChange}
                  maxLength={100}
                  autoComplete='new-password'
                  style={{paddingRight: '70px', fontSize: '16px', textTransform: 'uppercase'}}
                />
                {this.state.isQRScanLot && <img src={cameraIcon} onClick={() => this.handleInitQRScan(true)} />}
              </div>
              {this.state.couponApplied && <div style={{color: 'green', fontSize: '11px', marginTop: '3px'}}>
                Coupon applied successfully!
              </div>}
              <button type="button" className={this.state.discountAmount ? 'coupon-apply c-a-blk' : 'coupon-apply'} onClick={this.validateCoupon.bind(this)}>{this.state.discountAmount ? 'Remove' : 'Apply'}</button>
            </div>}
            <div style={{display: isPayment ? 'block' : 'none'}}>
              <h4 style={{paddingTop: 20}}>Payment</h4>
              <div style={{display: 'none'}} id='partners-button'>
                <div style={{display: this.state.isOnlyCard ? 'none' : 'block'}}>
                  <div>
                    <div style={{width: '150px'}}>
                    <div id="payment-request-button"></div>
                    </div>
                  </div>
                  <div class="separator">
                    <div class="line"></div>
                    <h6> or pay using your card </h6>
                    <div class="line"></div>
                  </div>
                </div>
              </div>
              <div className="card-info">
                <div id="card-element">
                </div>
              </div>
              <div className="error-msg" id="card-errors" role="alert"></div>
              <div class="group">
                <label>
                  <input onChange={this.handleChange} value={this.state.fields["cardholder_name"]} name="cardholder_name" class="field" placeholder="Cardholder Name" />
                </label>
              </div>    
              <div style={{paddingLeft: '15px', marginTop: '4px'}} className="error-msg">{this.state.errors['cardholder_name']}</div> 
            </div>
          </div>  
          {info.status != 'cancelled' && !this.state.hidePayBtn && !this.state.showPaymentDetails && <button onClick={this.showPaymentDetails.bind(this)} className='action-btn'  type="button">{this.getBtnLabel(info, total, true)}</button>}
          {info.status != 'cancelled' && !this.state.hidePayBtn && this.state.showPaymentDetails && <button onClick={() => this.preSubmit(total)} className='action-btn' id="pay-submit" type="button">{this.getBtnLabel(info, total)}</button>}
          {info.status === 'cancelled' && <button style={{backgroundColor: '#000', cursor: 'default'}} disabled='true' className='action-btn' type="button">Booking Cancelled</button>}
          
          <div>
            {info.total_fee > 0 && (this.state.hidePayBtn || (info.payment_status == "paid" &&  this.state.isMultipleTipsAllowed)) && <button style={{backgroundColor: '#3dc480'}} onClick={this.showPaidDetails.bind(this)} className='action-btn' type="button">{!info.parking_fee ? 'Tip Paid' : info.payment_type === "cash" && (info.parking_fee > 0 || info.tip2 > 0) ? 'Paid $' + ((info.parking_fee + info.tip2)/100).toFixed(2) : info.total_fee ? 'Paid $' + (info.total_fee/100).toFixed(2) : ''} </button>}
            <ul className={this.state.showPaidDetails ? "pay-timings paid-show" : "pay-timings paid-hide"}>
              <li>
                <span className="list-initial">Name</span>
                <span>{info.first_name} {info.last_name}</span>
              </li>
              <li>
                <span className="list-initial">Email</span>
                <span>{info.email}</span>
              </li>
              {(info.parking_fee > 0 || info.tip2 > 0) && <li>
                <span className="list-initial">Parking fee</span>
                <span>{(this.state.isOnlyPaid || this.state.isPartialPaid) && (info.parking_fee > 0 || info.tip2 > 0) ? '$' + ((info.parking_fee + info.tip2)/100).toFixed(2) : info.parking_fee ? '$' + (info.parking_fee/100).toFixed(2) : '$0.00'}</span>
              </li>}
              {info.paid_amount > 0 && <li>
                <span className="list-initial">Partial payment</span>
                <span>${info.paid_amount ? (info.paid_amount/100).toFixed(2) : ''}</span>
              </li>}
              <li>
                <span className="list-initial">{this.state.parkingId !== 5882 ?'Convenience fee':'Card fee'}</span>
                <span>${info.conv_fee ? (info.conv_fee/100).toFixed(2) : '0.00'}</span>
              </li>
              <li>
                <span className="list-initial">Tip</span>
                <span>${info.tip_amount ? (info.tip_amount/100).toFixed(2) : '0.00'}</span>
              </li>
              {info.validation_amount > 0 && <li>
                <span className="list-initial">Validation amount</span>
                <span>${info.validation_amount && info.validation_amount > info.parking_fee ? (info.parking_fee/100).toFixed(2) : info.validation_amount ? (info.validation_amount/100).toFixed(2) : ''}</span>
              </li>}
              {this.state.discountAmount > 0 && <li>
                <span className="list-initial">Discount amount</span>
                <span>${this.state.discountAmount && this.state.discountAmount > info.parking_fee ? (info.parking_fee/100).toFixed(2) : this.state.discountAmount ? (this.state.discountAmount/100).toFixed(2) : ''}</span>
              </li>}
              <li>
                <span className="list-initial">{info.parking_fee - info.discount_amount - info.validation_amount > 0 ? "Total Fee" : "Total Tip"}</span>
                <span>{info.payment_type === "cash" && (info.parking_fee > 0 || info.tip2 > 0) ? '$' + ((info.parking_fee + info.tip2)/100).toFixed(2) : info.total_fee ? '$'+ (info.total_fee/100).toFixed(2) : '$0.00'}</span>
              </li>
              <li>
                <span className="list-initial">Payment Status</span>
                <span className='pay-status'>
                  <div>{info.payment_status}</div>
                  {/* <div>(Visa card ending with xxxx)</div> */}
                </span>
              </li>
            </ul>
          </div>
          <div className="request-car-button-and-calendar-div" style={{ display: 'flex', position: 'relative' }}>
            {info.status != 'completed' && info.status != 'cancelled' && (!this.state.isPayRequestCar || this.state.isFreeParking) && !this.state.isHideRequestCar && <button id="car-request-btns" onClick={this.requestCar.bind(this)} style={{ backgroundColor: '#7c54a3', fontSize: !this.state.carRequested ? '15px' : '10px', width: (this.state.guest || this.state.o_guest) ? "80%" : "100%" }} className='action-btn action-btn-with-guest-oguest' type="button">{!this.state.carRequested ? "Request Your Car" : this.state.carReady ? "Your car is ready" : "We have forwarded your request. We will text you when your car is ready."}</button>}
            {(this.state.guest || this.state.o_guest) &&  (<div>
                <span style={{ textAlign: 'center', cursor: 'pointer' }} className="requestCar">
                  <img style={{ height: 35, position: 'absolute', top: '20px', right: '10px' }} src={calendarIcon} onClick={() => this.handleCarRequestedIconClicked()} />
                </span>
              </div>)}
            </div>
          {this.state.carRequested && <div style={{marginTop: '20px'}}>
            <ul class={info && info.car_ready == "true" ? "steps steps-all-complete" : "steps"}>
              <li class="step step--complete step--active">
                <span class="step__icon"></span>
                <span class="step__label">Car Requested</span>
              </li>
              <li class={info && info.car_on_the_way === true ? "step step--complete step--active" : "step step--incomplete step--inactive"}>
                <span class="step__icon"></span>
                <span style={{color: '#000'}} class="step__label">Car on the Way</span>
              </li>
              <li class={info && info.car_ready == "true" ? "step step--complete step--active" : "step step--incomplete step--inactive"}>
                <span class="step__icon"></span>
                <span style={{color: '#000'}} class="step__label">Car Ready</span>
              </li>
            </ul>
          </div>}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          {/* {this.state.displayPast && <button
            className='expand-btns'
            style={{  width: !this.state.displayUpcoming ? '100%' : '50%', backgroundColor: this.state.requestType === PAST_REQUEST ?  'rgb(220, 110, 125)' : 'black' }}
            onClick={this.handlePastRequestsClick}
          >
            Past Requests
          </button>} */}
         { this.state.displayUpcoming &&  <button
            className='expand-btns'
            style={{ marginLeft: this.state.displayPast ? '20px' : '0px', width: !this.state.displayPast ? '100%' : '50%', backgroundColor: this.state.requestType === UPCOMING_REQUEST ?  'rgb(220, 110, 125)' : 'black' }}
            onClick={this.handleUpcomingRequestsClick}
          >
            Upcoming Requests
          </button>}
        </div>
        {(this.state.guest || this.state.o_guest) && <div>
          <ExpandTray timeZone={this?.state?.timeZone} cancelCarRequest={this.cancelCarRequest}  requestList={this.state.requestList} requestType = {this.state.requestType}>
          </ExpandTray>
        </div>}
      </div>
          {!this.state.isOnlyCard && <div style={{display: !this.state.hidePayBtn && this.state.showPaymentDetails ? 'block' : 'none'}}>
            <p style={{padding: '10px 0'}}>For any assistance or to find parking locations and valets in the future, download our app.</p>
            <div className="download-app">
              <a target="_blank" href="https://apps.apple.com/in/app/parkquility/id1543951488"><img src={iosIcon} /></a>
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.parkquility"><img src={googleIcon} /></a>
              <div style={{clear: 'both'}}></div>
            </div>
          </div>}
          {!info.monthly_parker && this.state.hidePayBtn && <div className='reciept'>
            {!this.state.emailSent ? <div>
                <p>To obtain your receipt, please enter your email below:</p>
                {/* <div>
                    <input onChange={(e) => this.handleNameChange(e, 'first_name')} className='f_name' type="text" value={info.first_name} placeholder='First name'/>
                    <input onChange={(e) => this.handleNameChange(e, 'last_name')} className='l_name' type="text" value={info.last_name} placeholder='Last name'/>
                    <div style={{clear: 'both'}}></div>
                </div> */}
                <div style={{marginTop: '15px'}}>
                  <input id="email" type="email" placeholder='Email ID'/>
                  <button type="button" onClick={() => this.emailReceipt(info.id)}>&#x2192;</button>
                </div>
              </div> : <p style={{textAlign: 'center', marginTop: '35px', fontSize: '13px', color: '#DC6E7D'}}>Receipt has been sent to your email id.</p>}
          </div>}
          {this.state.isShowHotelTerms && <div className='terms'>
            <p>Please ensure to read the following policies:</p>
            <ol>
              <li>The check out time is 12 PM. If you do not take your car before 3 PM, we will automatically extend your reservation for another day.</li>
              <li>If you need to use the valet for a few more hours, please contact the valet before 3 PM. You will be charged hourly in that case.</li>
            </ol>
            <p style={{textAlign: 'center'}}></p>
          </div>}
          {this.state.isShowTerms && <div className='terms'>
            <p>Please ensure to read the following terms and conditions:</p>
            <ol>
              <li>If you leave your car unattended and you don't leave your keys with the Front Desk, your vehicle will be towed at your own risk and expense.</li>
              <li>We are not responsible for any valuable items) left in the car such as: jewerly, cash, electronics, etc.</li>
              <li>Not responsible for technical damage.</li>
              <li>Customer must inspect vehicle with valet when arriving and before leaving.</li>
              <li>The company is not responsible for any damages or claim made after vehicle left the ramp.</li>
              <li>Customer must sign ticket in order to present a claim, otherwise customer waives any responsability from Valet Operator once the Ticket has been issued.</li>
              <li>Although reasonable care is given, cars are parked at owners risk. No liability is assumed by management for loss or damage by fire, theft or any other cause to, or by the vehicle while in custody of management. All claims for adjustment must be presented before vehicle is taken from facility. Cars driven, called for, or delivered at the owners risk, and any person so driving becomes the agent of the owner solely.</li>
            </ol>
            <p style={{textAlign: 'center'}}>THANK YOU FOR YOUR VISIT.</p>
          </div>}
          <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
        </form>
        {this.state.isQRScan && <div className="qr-scan-popup">
          <img src={qrcode} />
          <span onClick={() => this.handleInitQRScan(false)} id="sm-close">&times;</span>
          <div>
            <QrReader
              constraints={{facingMode: 'environment'}}
              scanDelay={1000}
              onResult={(result, error) => this.handleQRCodeScanResult(result, error)}
              style={{ width: '100%' }}
            />
          </div>
        </div>}
      </div>      
    )
  }
}
